// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3SEUm","checkboxCol":"Table_checkboxCol__1c_7L","emailCol":"Table_emailCol__2jyJ7","actionCol":"Table_actionCol__2BpLT"};